module.exports = "\r\n\r\n<app-loader></app-loader>\r\n<app-header></app-header>\r\n\r\n<router-outlet></router-outlet>\r\n\r\n<app-footer></app-footer>\r\n"